import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * ReportServiceMgeSvr
 */
export class ReportServiceMgeSvr {
    constructor() {
        this.baseurl = 'ReportServiceMgeSvr.assx/';
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportPDFContentOfEdit(token, reportName, param) {
        return request.post(this.baseurl + 'getReportPDFContentOfEdit', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String
     */
    getReportMenu(token) {
        return request.post(this.baseurl + 'getReportMenu', Qs.stringify({
            token: token
        }));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportPDFContent(token, reportName, param) {
        return request.post(this.baseurl + 'getReportPDFContent', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportExcelContent(token, reportName, param) {
        return request.post(this.baseurl + 'getReportExcelContent', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam, isEdit:boolean
     */
    getReportFileParam(token, reportName, param, isEdit) {
        return request.post(this.baseurl + 'getReportFileParam', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString(),
            isEdit: isEdit
        }));
    }

    /**
     * 
     * 
     */
    GetVersion() {
        return request.post(this.baseurl + 'GetVersion', Qs.stringify({}));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportExcelContentOfEdit(token, reportName, param) {
        return request.post(this.baseurl + 'getReportExcelContentOfEdit', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String, reportName:String, tableCount:int, param:ReportParam, isEdit:boolean
     */
    getReportHmtlContentAndReoprtName(token, reportName, tableCount, param, isEdit) {
        return request.post(this.baseurl + 'getReportHmtlContentAndReoprtName', Qs.stringify({
            token: token,
            reportName: reportName,
            tableCount: tableCount,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString(),
            isEdit: isEdit
        }));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportHmtlContentOfEdit(token, reportName, param) {
        return request.post(this.baseurl + 'getReportHmtlContentOfEdit', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String, reportName:String, param:ReportParam
     */
    getReportHmtlContent(token, reportName, param) {
        return request.post(this.baseurl + 'getReportHmtlContent', Qs.stringify({
            token: token,
            reportName: reportName,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString()
        }));
    }

    /**
     * 
     * token:String, keyId:String
     */
     getPublicReportFill(token, keyId) {
        return request.post(this.baseurl + 'getPublicReportFill', Qs.stringify({
            token: token,
            keyId: keyId,
        }));
    }
}